import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  ResponsiveContainer,
  LabelList,
  Cell,
} from "recharts";
import { amountFormatter } from "../../utils/utils";

const colors = {
  blueTheme: [
    "#E1C33E",
    "#FFE0C2",
    "#FFB0C1",
    "#9776C9",
    "#66B032",
    "#3B7EE3",
    "#5E95E8",
  ],
};

const MimaAmountBarChart = ({ data, currency }) => {
  const formattedData = data.map((item) => ({
    name: item.name,
    value: item.value,
    formattedValue: amountFormatter(currency).format(item.value),
  }));

  return (
    <ResponsiveContainer width="100%" height={data.length * 50 + 10}>
      <BarChart
        layout="vertical"
        data={formattedData}
        margin={{ top: 20, right: 90, left: 60, bottom: 5 }}
      >
        <XAxis
          type="number"
          axisLine={false}
          tickLine={false}
          tick={{ display: "none" }}
        />
        <YAxis
          dataKey="name"
          type="category"
          axisLine={false}
          tick={{ fontSize: 12 }}
        />
        <Bar dataKey="value" barSize={20} fill="#8884d8">
          <LabelList
            dataKey="formattedValue"
            position="right"
            fill="black"
            style={{ fontSize: "1.4rem" }}
          />
          {colors.blueTheme.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={colors.blueTheme[index % colors.blueTheme.length]}
            />
          ))}
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default MimaAmountBarChart;
